// Convert thumbnail URLs to original image URLs
function getOriginalURL(url) {
  if (!url) return url;
  if (url.indexOf("/medium/") !== -1) {
    return url.replace("/medium/", "/original/");
  } else if (url.indexOf("/small/") !== -1) {
    return url.replace("/small/", "/original/");
  } else if (url.indexOf("/large/") !== -1) {
    return url.replace("/large/", "/original/");
  }
  return url;
}

document.addEventListener("click", function (e) {
  const target = e.target;

  // Handle general image click inside allowed containers
  if (target.tagName.toLowerCase() === "img") {
    const isInsideAllowedContainer =
      document.querySelector("#topic-desc-content")?.contains(target) ||
      document.querySelector("#news-desc-content")?.contains(target) ||
      document.querySelector("#saved-posts-tab")?.contains(target) ||
      document.querySelector("#comment-list")?.contains(target) ||
      document.querySelector("#top-comments-content")?.contains(target) ||
      document.querySelector("#tab-how")?.contains(target) ||
      document.querySelector("#tab-details")?.contains(target) ||
      document.querySelector("#tab-faqs")?.contains(target);

    const hasVotingStatusClass = Array.from(target.classList).some(className =>
      /^voting_status_\d+$/.test(className)
    );

    const isExcludedImage =
      target.classList.contains("user-photo") || target.classList.contains("emoji-image");

    const anchorParent = target.closest("a");
    const isInsideReEmojisAnchor = anchorParent?.classList.contains("re-emojis");

    const isInsideReactionsContainer = target.closest(".reactions-container") !== null;

    if (
      isInsideAllowedContainer &&
      !isExcludedImage &&
      !isInsideReEmojisAnchor &&
      !hasVotingStatusClass &&
      !isInsideReactionsContainer
    ) {
      const imageSrc = target.src || target.dataset.imageOriginal;
      toggleExpandPopup(false, getOriginalURL(imageSrc));
      return;
    }
  }

  // Handle click on the expand button
  if (target.id === "expand-image") {
    const imageSrc = target.src || target.dataset.imageOriginal;
    toggleExpandPopup(false, getOriginalURL(imageSrc));
  }
});

function toggleExpandPopup(isOpen, src) {
  let expandImagePopup = document.getElementById("expand-image-popup");
  if (!isOpen) {
    expandImagePopup.innerHTML = getExpandImagePopup();
    document.getElementById("original-image").src = src;
    expandImagePopup.addEventListener("click", function(e) {
      if (e.target && ['img', 'path', 'svg'].includes(e.target.tagName.toLowerCase())) {
        return false;
      } else {
        toggleExpandPopup(true)
      }
    })
  }
  let expandImageOptions = {
    backdrop: 'dynamic',
    backdropClasses:
        'bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-[700]',
    closable: true,
    onHide: () => {},
    onShow: () => {
      let closeExpandImage = document.getElementById("close-expand")
      if (closeExpandImage) {
        closeExpandImage.addEventListener("click", () => {
          toggleExpandPopup(true);
        })
      }

      // Zoom toggle functionality
      let originalImage = document.getElementById("original-image");
      if (originalImage) {
        originalImage.addEventListener("click", (e) => {
          e.stopPropagation();
          const isZoomed = originalImage.classList.contains("original-image-zoomed");
          if (isZoomed) {
            // Zoom out - apply constraints
            originalImage.classList.remove("original-image-zoomed");
            originalImage.classList.add("original-image-normal");
            originalImage.style.maxHeight = "70dvh";
            originalImage.style.maxWidth = "100%";
            originalImage.style.cursor = "zoom-in";
          } else {
            // Zoom in - remove constraints
            originalImage.classList.remove("original-image-normal");
            originalImage.classList.add("original-image-zoomed");
            originalImage.style.maxHeight = "none";
            originalImage.style.maxWidth = "none";
            originalImage.style.cursor = "zoom-out";
          }
        });
      }

      // Auto-hide zoom instruction message after 2 seconds
      let zoomMsg = document.getElementById("img-zoom-msg");
      if (zoomMsg) {
        setTimeout(() => {
          zoomMsg.style.opacity = "0";
          setTimeout(() => {
            zoomMsg.style.display = "none";
          }, 300);
        }, 2000);
      }

      let unblurExpandImage = document.getElementById("unblur-expand")
      if (unblurExpandImage) {
        unblurExpandImage.addEventListener("click", () => {
          let img = document.getElementById("original-image");
          img.classList.toggle('content-blur');
          let isBlurred = img.classList.contains('content-blur');

          unblurExpandImage.innerHTML = isBlurred
            ? `<svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-primary-text-light dark:text-secondary-text-dark" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                 <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.477 0-8.268-2.943-9.542-7a9.956 9.956 0 012.503-4.255m1.5-1.5A9.956 9.956 0 0112 5c4.477 0 8.268 2.943 9.542 7a9.956 9.956 0 01-4.208 5.165M3 3l18 18"/>
               </svg>`
            : `<svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-primary-text-light dark:text-secondary-text-dark" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                 <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                 <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
               </svg>`;
        })
      }
    },
    onToggle: () => {},
  };
  let expandImageInstanceOptions = {
    id: 'modalElexpandimage',
    override: true
  };
  let modal_expandimage = new Modal(expandImagePopup, expandImageOptions, expandImageInstanceOptions);
  if (isOpen) {
    modal_expandimage.hide();
  } else {
    modal_expandimage.show();
  }
}

function getExpandImagePopup() {
  return `
    <div class="flex justify-center items-center bg-white dark:bg-background-dark w-full h-full">
      <div class="md:max-w-[80%] max-w-[90%] md:max-h-[70dvh] max-h-[80dvh] overflow-scroll" id="original-image-container">
        <img class="lazyload max-h-[70dvh] rounded-bradius10 w-full cursor-zoom-in original-image-normal" id="original-image" src="" loading="lazy">
        <div class="absolute flex justify-between mx-4 py-4 right-0 top-0">
          <div id="close-expand" class="cursor-pointer">
            <!-- Close icon SVG -->
            <svg class="w-[20px] h-[20px] text-primary-icon-light dark:text-primary-icon-dark" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18 17.94 6M18 18 6.06 6"/>
            </svg>
          </div>
        </div>
        <div id="img-zoom-msg" class="fixed bottom-[50px] left-1/2 -translate-x-1/2 w-[90%] max-w-[400px] h-[50px] bg-black/60 text-white text-base font-bold flex justify-center items-center z-[1000] rounded-lg transition-opacity duration-300">
          Tap On Image to Zoom In / Out
        </div>
      </div>
    </div>`;
}

